import React from 'react';

const Footer = () => {
  return (
    <footer className="relative w-full bg-black overflow-hidden">
      {/* Enhanced Blue Gradient Background */}
      <div className="absolute inset-0 z-0">
        {/* Multiple layered gradients for depth */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-blue-500/30 rounded-full blur-[200px]" />
        <div className="absolute top-1/3 left-1/3 w-[800px] h-[800px] bg-blue-500/25 rounded-full blur-[180px]" />
        <div className="absolute bottom-1/4 right-1/3 w-[700px] h-[700px] bg-blue-400/20 rounded-full blur-[150px]" />
        <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] bg-teal-500/15 rounded-full blur-[120px]" />
        
        {/* Animated floating orbs */}
        <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-[100px] animate-pulse" />
        <div className="absolute bottom-1/3 right-1/4 w-[350px] h-[350px] bg-blue-400/15 rounded-full blur-[90px] animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 z-[1] opacity-10">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="footer-grid" width="50" height="50" patternUnits="userSpaceOnUse">
              <path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#footer-grid)" />
        </svg>
      </div>

      {/* Main Content */}
      <div className="relative z-10">
        {/* Main footer content */}
        <div className="backdrop-blur-md bg-white/[0.02] px-4 sm:px-6 lg:px-10 xl:px-16 py-12 sm:py-16 lg:py-20">
          <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-transparent pointer-events-none" />
          <div className="max-w-[1600px] mx-auto relative">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 xl:gap-16">
              {/* Left section - Organization Info */}
              <div className="lg:col-span-4 xl:col-span-3">
                <div className="flex flex-col items-start gap-6">
                  <div className="flex items-center gap-4">
                    <img 
                      src="images/favicon.ico" 
                      alt="Jamiat Ahle Hadees Logo" 
                      className="w-16 h-16 sm:w-20 sm:h-20 object-contain flex-shrink-0"
                    />
                    <h2 className="text-xl sm:text-2xl font-bold text-white leading-tight">
                      Jamiat Ahle Hadees
                    </h2>
                  </div>
                  
                  <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                    Subai Jamiat Ahle Hadees Andhra Pradesh, India. It is a Supervising organization over all District (Zilayi) jamiats, City (shehri) or local (maqami) jamiats within the state of Andhra Pradesh.
                  </p>
                </div>
              </div>

              {/* Right section - Links Grid */}
              <div className="lg:col-span-8 xl:col-span-9">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-6 lg:gap-8">
                  {/* About Us Column */}
                  <div>
                    <h3 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-5 pb-2 border-b border-white/10">
                      About Us
                    </h3>
                    <ul className="space-y-3">
                      {[
                        { name: 'Golden Past', href: '/aboutus' },
                        { name: 'Office Bearers', href: '/officebearers' },
                        { name: 'District Committee', href: '/commitee' },
                        { name: 'Brochures', href: '/brochures' }
                      ].map((item) => (
                        <li key={item.name}>
                          <a href={item.href} className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300">
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Services Column */}
                  <div>
                    <h3 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-5 pb-2 border-b border-white/10">
                      Services
                    </h3>
                    <ul className="space-y-3">
                      {[
                        { name: 'Our Masajids', href: '/masajids' },
                        { name: 'Donators', href: '/' },
                        { name: 'Our Causes', href: '/ourcause' }
                      ].map((item) => (
                        <li key={item.name}>
                          <a href={item.href} className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300">
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Resources Column */}
                  <div>
                    <h3 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-5 pb-2 border-b border-white/10">
                      Resources
                    </h3>
                    <ul className="space-y-3">
                      {[
                        { name: 'Ask with Ulama', href: '/contactus' },
                        { name: 'Library', href: '/library' },
                        { name: 'Events', href: '/eventslist' }
                      ].map((item) => (
                        <li key={item.name}>
                          <a href={item.href} className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300">
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Support Column */}
                  <div>
                    <h3 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-5 pb-2 border-b border-white/10">
                      Support
                    </h3>
                    <ul className="space-y-3">
                      <li>
                        <a href="/donate" className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300 font-semibold">
                          Make Donation
                        </a>
                      </li>
                      <li>
                        <a href="/contactus" className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300">
                          Contact Us
                        </a>
                      </li>
                      <li>
                        <a href="/privacy-policy" className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300">
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a href="/terms" className="text-gray-400 text-sm sm:text-base hover:text-white transition-all duration-300">
                          Terms of Service
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Contact Information Column */}
                  <div>
                    <h3 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-5 pb-2 border-b border-white/10">
                      Contact
                    </h3>
                    <div className="space-y-4">
                      <div className="group">
                        <div className="flex items-start gap-2 mb-1">
                          <svg className="w-4 h-4 text-gray-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                          </svg>
                          <span className="text-gray-500 text-xs uppercase tracking-wide">Email</span>
                        </div>
                        <a href="mailto:apstateahlehadees@gmail.com" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors block break-words leading-relaxed">
                          apstateahlehadees@gmail.com
                        </a>
                      </div>
                      
                      <div className="group">
                        <div className="flex items-start gap-2 mb-1">
                          <svg className="w-4 h-4 text-gray-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                          </svg>
                          <span className="text-gray-500 text-xs uppercase tracking-wide">Phone</span>
                        </div>
                        <a href="tel:+919963372233" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors block">
                          +91 99633 72233
                        </a>
                      </div>
                      
                      <div className="group">
                        <div className="flex items-start gap-2 mb-1">
                          <svg className="w-4 h-4 text-gray-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                          </svg>
                          <span className="text-gray-500 text-xs uppercase tracking-wide">Address</span>
                        </div>
                        <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                          2nd Floor, Markaz Masjid, Hamid Street, Islampet, Vijayawada, Andhra Pradesh, India 520001
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.08] backdrop-blur-md bg-white/[0.02] px-4 sm:px-6 lg:px-10 xl:px-16 py-6 sm:py-8">
          <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-transparent pointer-events-none" />
          <div className="max-w-[1400px] mx-auto relative">
            <div className="flex flex-col lg:flex-row justify-between items-center gap-6 lg:gap-8">
              {/* Copyright */}
              <div className="text-center lg:text-left">
                <p className="text-gray-500 text-sm sm:text-base">
                  © {new Date().getFullYear()} Jamiat Ahle Hadees Andhra Pradesh. All rights reserved.
                </p>
              </div>

              {/* Social icons */}
              <div className="flex items-center gap-4 sm:gap-5">
                {/* Facebook */}
                <a 
                  href="https://www.facebook.com/apahlehadees" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                  aria-label="Facebook"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                
                {/* WhatsApp */}
                <a 
                  href="https://wa.me/919963372233" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                  aria-label="WhatsApp"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
                
                {/* Twitter/X */}
                <a 
                  href="https://x.com/apahlehadees" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                  aria-label="Twitter"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                
                {/* Email */}
                <a 
                  href="mailto:apstateahlehadees@gmail.com" 
                  className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                  aria-label="Email"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </a>
                
                {/* YouTube */}
                <a 
                  href="https://www.youtube.com/@markazijamemasjidahlehadees" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                  aria-label="YouTube"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
                
                {/* Map Pin */}
                <a 
                  href="https://maps.google.com/?q=2nd Floor, Markaz Masjid, Hamid Street, Islampet, Vijayawada, Andhra Pradesh, India 520001" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                  aria-label="Location"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Noise texture overlay */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none z-20 mix-blend-overlay">
        <svg width="100%" height="100%">
          <filter id="noise">
            <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" stitchTiles="stitch"/>
          </filter>
          <rect width="100%" height="100%" filter="url(#noise)"/>
        </svg>
      </div>
    </footer>
  );
};

export default Footer;

// import React from 'react';

// const Footer = () => {
//   return (
//     <footer className="relative w-full bg-black overflow-hidden">
//       {/* Enhanced Blue Gradient Background */}
//       <div className="absolute inset-0 z-0">
//         {/* Multiple layered gradients for depth */}
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-blue-500/30 rounded-full blur-[200px]" />
//         <div className="absolute top-1/3 left-1/3 w-[800px] h-[800px] bg-blue-500/25 rounded-full blur-[180px]" />
//         <div className="absolute bottom-1/4 right-1/3 w-[700px] h-[700px] bg-blue-400/20 rounded-full blur-[150px]" />
//         <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] bg-teal-500/15 rounded-full blur-[120px]" />
        
//         {/* Animated floating orbs */}
//         <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-[100px] animate-pulse" />
//         <div className="absolute bottom-1/3 right-1/4 w-[350px] h-[350px] bg-blue-400/15 rounded-full blur-[90px] animate-pulse" style={{ animationDelay: '1s' }} />
//       </div>

//       {/* Grid Pattern Overlay */}
//       <div className="absolute inset-0 z-[1] opacity-10">
//         <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
//           <defs>
//             <pattern id="footer-grid" width="50" height="50" patternUnits="userSpaceOnUse">
//               <path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5"/>
//             </pattern>
//           </defs>
//           <rect width="100%" height="100%" fill="url(#footer-grid)" />
//         </svg>
//       </div>

//       {/* Main Content */}
//       <div className="relative z-10">
//         {/* Top section with tabs */}
//         <div className="border-b border-white/[0.08] backdrop-blur-md bg-white/[0.02] px-4 sm:px-6 lg:px-8 py-6">
//           <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-transparent pointer-events-none" />
//           <div className="max-w-7xl mx-auto relative">
//             <div className="flex gap-3">
//               <button className="px-4 py-2 text-sm font-medium text-white bg-transparent border border-white/20 rounded-md hover:border-white/40 hover:bg-white/5 transition-all backdrop-blur-sm">
//                 New Design
//               </button>
//               <button className="px-4 py-2 text-sm font-medium text-gray-400 bg-transparent border border-transparent rounded-md hover:text-white hover:bg-white/5 transition-all">
//                 Archived
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Main footer content */}
//         <div className="backdrop-blur-md bg-white/[0.02] px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
//           <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-transparent pointer-events-none" />
//           <div className="max-w-7xl mx-auto relative">
//             <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
//               {/* Left section - Newsletter */}
//               <div className="lg:col-span-4">
//                 <div className="flex items-center gap-3 mb-6">
//                   <svg className="w-8 h-8 fill-white" viewBox="0 0 16 16">
//                     <path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z" />
//                   </svg>
//                   <span className="text-2xl font-semibold text-white">GitHub</span>
//                 </div>
                
//                 <div className="space-y-4">
//                   <h3 className="text-white text-base font-semibold">
//                     Subscribe to our developer newsletter
//                   </h3>
//                   <p className="text-gray-400 text-sm leading-relaxed">
//                     Get tips, technical guides, and best practices. Twice a month. Right in your inbox.
//                   </p>
//                   <button className="px-5 py-2.5 text-sm font-medium text-white bg-white/5 border border-white/20 rounded-md hover:bg-white/10 hover:border-white/30 transition-all backdrop-blur-sm">
//                     Subscribe
//                   </button>
//                 </div>
//               </div>

//               {/* Right section - Links Grid */}
//               <div className="lg:col-span-8">
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
//                   {/* Product Column */}
//                   <div>
//                     <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
//                       Product
//                     </h3>
//                     <ul className="space-y-3">
//                       {['Features', 'Enterprise', 'Copilot', 'Security', 'Pricing', 'Team', 'Resources', 'Roadmap', 'Compare GitHub'].map((item) => (
//                         <li key={item}>
//                           <a href="#" className="text-blue-400 text-sm hover:text-blue-300 hover:underline transition-all">
//                             {item}
//                           </a>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>

//                   {/* Platform Column */}
//                   <div>
//                     <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
//                       Platform
//                     </h3>
//                     <ul className="space-y-3">
//                       {['Developer API', 'Partners', 'Education', 'GitHub CLI', 'GitHub Desktop', 'GitHub Mobile'].map((item) => (
//                         <li key={item}>
//                           <a href="#" className="text-blue-400 text-sm hover:text-blue-300 hover:underline transition-all">
//                             {item}
//                           </a>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>

//                   {/* Support Column */}
//                   <div>
//                     <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
//                       Support
//                     </h3>
//                     <ul className="space-y-3">
//                       {['Docs', 'Community Forum', 'Professional Services', 'Premium Support', 'Skills', 'Status', 'Contact GitHub'].map((item) => (
//                         <li key={item}>
//                           <a href="#" className="text-blue-400 text-sm hover:text-blue-300 hover:underline transition-all">
//                             {item}
//                           </a>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>

//                   {/* Company Column */}
//                   <div>
//                     <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
//                       Company
//                     </h3>
//                     <ul className="space-y-3">
//                       {['About', 'Why GitHub', 'Customer stories', 'Blog', 'The ReadME Project', 'Careers', 'Newsroom', 'Inclusion', 'Social Impact', 'Shop'].map((item) => (
//                         <li key={item}>
//                           <a href="#" className="text-blue-400 text-sm hover:text-blue-300 hover:underline transition-all">
//                             {item}
//                           </a>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom bar */}
//         <div className="border-t border-white/[0.08] backdrop-blur-md bg-white/[0.02] px-4 sm:px-6 lg:px-8 py-6">
//           <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-transparent pointer-events-none" />
//           <div className="max-w-7xl mx-auto relative">
//             <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
//               {/* Copyright and links */}
//               <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 text-xs text-gray-400">
//                 <span>© 2025 GitHub, Inc.</span>
//                 <div className="flex flex-wrap justify-center items-center gap-4">
//                   <a href="#" className="hover:text-blue-400 hover:underline transition-colors">Terms</a>
//                   <a href="#" className="hover:text-blue-400 hover:underline transition-colors">Privacy (Updated 02/2024)</a>
//                   <a href="#" className="hover:text-blue-400 hover:underline transition-colors">Sitemap</a>
//                   <a href="#" className="hover:text-blue-400 hover:underline transition-colors">What is Git?</a>
//                   <a href="#" className="hover:text-blue-400 hover:underline transition-colors">Manage cookies</a>
//                   <a href="#" className="hover:text-blue-400 hover:underline transition-colors">Do not share my personal information</a>
//                 </div>
//               </div>

//               {/* Social icons */}
//               <div className="flex items-center gap-4">
//                 {/* LinkedIn */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
//                   </svg>
//                 </a>
                
//                 {/* Instagram */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//                   </svg>
//                 </a>
                
//                 {/* YouTube */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//                   </svg>
//                 </a>
                
//                 {/* X (Twitter) */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
//                   </svg>
//                 </a>
                
//                 {/* TikTok */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
//                   </svg>
//                 </a>
                
//                 {/* Twitch */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
//                   </svg>
//                 </a>
                
//                 {/* GitHub */}
//                 <a href="#" className="text-gray-400 hover:text-white transition-colors">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 16 16">
//                     <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
//                   </svg>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Noise texture overlay */}
//       <div className="absolute inset-0 opacity-[0.015] pointer-events-none z-20 mix-blend-overlay">
//         <svg width="100%" height="100%">
//           <filter id="noise">
//             <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" stitchTiles="stitch"/>
//           </filter>
//           <rect width="100%" height="100%" filter="url(#noise)"/>
//         </svg>
//       </div>
//     </footer>
//   );
// };

// export default Footer;





// old design working 12/12/25

// import React from 'react';
// import { Link } from 'react-router-dom';

// function Footer() {
//   return (
//     <div className="relative">
//       {/* Green Background Footer Wrapper with extra top padding */}
//       <div className="bg-[#45a388] pt-56  md:pt-16 relative z-0">
//         {/* Footer Bottom Content */}
//         <div className="mt-80 md:mt-56 px-4 md:px-10 relative z-10">
//           <div className="flex flex-col md:items-end md:pr-10 gap-4">
//             <p className="text-center md:text-right text-sm sm:text-base">Subscribe for Weekly Updates</p>
//             <div className="relative w-full sm:w-[90%] md:w-[400px]">
//               <input
//                 type="text"
//                 placeholder="Enter your email"
//                 className="border border-gray-300 rounded-xl pl-4 pr-10 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
//               />
//               <button className="absolute right-2 top-1 bg-[#225B4B] text-white px-4 py-1 rounded hover:bg-[#214f42] text-sm">
//                 Signup
//               </button>
//             </div>
//           </div>
//           <div className="text-center text-xs sm:text-sm mt-4">
//             <p>© 2024 Jamiate Ahle Hadees, Andhra Pradesh.</p>
//             <p>
//         <Link to="/policies" className=" hover:underline">
//           Privacy Policy
//         </Link>
//       </p>
//             <p>Powered by Alif Dynamics Inc. Canada.</p>
//           </div>
//         </div>
//       </div>

//       {/* Floating Footer Card */}
//       <div className="absolute left-1/2 top-0 transform -translate-x-1/2 -translate-y-1/2 z-20 w-[95%] sm:w-[90%] md:w-[90%] lg:w-[80%] bg-white border-2 border-gray-300 rounded-3xl px-4 py-6 md:px-10 md:py-10 flex flex-col md:flex-row justify-around items-start gap-10 shadow-lg">
        
//         {/* About Us */}
//          <div className='flex flex-col items-center text-center gap-4 w-full md:w-1/3'>
//         <Link to='/'>
//           <img className='w-[50%]"' src='images/favicon.ico' alt="Logo" />
//         </Link>
//       </div>
//         <div className="flex flex-col items-center text-center gap-4 w-full md:w-1/3">
//           <p className="text-xl sm:text-2xl md:text-3xl font-bold">About Us</p>
//           <p className="text-sm sm:text-base leading-6 max-w-md">
//             Jamiat Ahle Hadees Andhra Pradesh Subai Jamiat Ahle Hadees Andhra Pradesh, India. It is a Supervising organization over all District (Zilayi) jamiats, City (shehri) or local (maqami) jamiats within the state of Andhra Pradesh.
//           </p>
//         </div>

//         {/* Contact Info */}
//         <div className="flex flex-col text-center gap-4 w-full md:w-1/3">
//           <p className="text-xl sm:text-2xl md:text-3xl font-bold">Contact Info</p>
//          <div className="flex gap-3 items-center text-sm sm:text-base justify-center">
//   <img className="w-5 md:w-6" src="images/mailimg.png" alt="mail" />
//   <a
//     href="mailto:apstateahlehadees@gmail.com"
//     className="hover:underline"
//   >
//     apstateahlehadees@gmail.com
//   </a>
// </div>

//           <div className="flex gap-3 items-center text-sm sm:text-base justify-center">
//             <img className="w-4 md:w-5" src="images/mobileimg.png" alt="phone" />
//             <span>+91 99633 72233</span>
//           </div>
//           <div className="flex gap-3 text-left text-sm sm:text-base justify-center">
//             <img className="w-4 h-6 md:w-5" src="images/location.png" alt="location" />
//             <a href='https://maps.app.goo.gl/mSCC243zZd7GWWz59'>
//               <p className="leading-5">
//                 2nd Floor, Markaz Masjid,<br />
//                 Hamid Street, Islampet, Vijayawada,<br />
//                 Andhra Pradesh, India 520001.
//               </p>
//             </a>
//           </div>
          
//           <div className="flex gap-5 justify-center mt-3">
//             <a href="https://x.com/apahlehadees" target="_blank" rel="noopener noreferrer">
//               <img src="images/twitter.png" alt="twitter" className="w-5 h-5" />
//             </a>
//             <a href="https://www.facebook.com/apahlehadees" target="_blank" rel="noopener noreferrer">
//               <img src="images/fb.png" alt="facebook" className="w-5 h-5" />
//             </a>
//             {/* <img src="images/linkedin.png" alt="linkedin" className="w-5 h-5" /> */}
//              <a href="mailto:apstateahlehadees@gmail.com" target="_blank" rel="noopener noreferrer">
//   <img src="images/google.png" alt="google" className="w-5 h-5" />
// </a>
//           </div>
//         </div>

      
//       </div>
//     </div>
//   );
// }

// export default Footer;

